import { Injectable, NgModule } from '@angular/core';
import { Observable } from 'rxjs';
import { HTTP_INTERCEPTORS, HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UserData } from './shared/models/user.model';
import { Constants } from './app.constants';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  userData = new UserData();
  constructor() { }
  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
      
    let apiKey = environment.APIKey;  
    this.userData = JSON.parse(localStorage.getItem("userprofile")!);
    if (apiKey != null && apiKey != undefined && this.userData != null && this.userData != undefined && req.url.indexOf("AWSAccessKeyId") == -1) {
      const newReq = req.clone({
        headers: new HttpHeaders({
          [Constants.apiKey] : apiKey,
          [Constants.authorization]:  this.userData.AccessToken,
        })

      });

      return next.handle(newReq);
    }
    else {
      return next.handle(req);
    }
  }
};

@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true
    }
  ]
})
export class HttpInterceptorModule { }
